module.exports = __webpack_public_path__ + "static/sorun-belirleme-b1f10d516ae15d527252a35f7cb45ac6.png";